import React, {useEffect, useState} from "react";
import FirstStep from "./steps/first";
import SecondStep from "./steps/second";
import ThirdStep from "./steps/third";
import FourthStep from "./steps/fourth";
import FifthStep from "./steps/fifth";
import {companyService} from "../../../../services";
import {notification} from "antd";
import ModalListShipCompanies from "../../list-ship-companies";
import FillInnStep from "./steps/inn";
import {legalEntityService} from "../../../../services/legal-entity.service";
import moment from "moment";
import {stringsHelper} from "../../../../helpers/strings.helper";
import i18n from "../../../../i18n";

const getErrorDescription = (error) => {
  if (typeof error === "string") {
    return error;
  }
  if (error && typeof error.message === "string") {
    return error.message;
  }
  return String(error || "");
};

export default function CreateRusLegalEntity({
    isActive = false,

    currentStep,
    setCurrentStep,

    orgFormId,
    isProprietor,
    workWithNds,
    countryId,

    setLoading,

    setShowModal,

    setStepsList,

    changeStepEvent,
    setChangeStepEvent,

    createLegalEntityEvent,
    setCreateLegalEntityEvent,
    purposeType,
    taxType,
    taxPercent,

    setIsShowParent, 
    isAgree
}) {
  const [showModalListShipCompanies, setShowModalListShipCompanies] = useState(false);
  const [legalEntityId, setLegalEntityId] = useState(null);

  const [fieldsErrors, setFieldsErrors] = useState({});

  const [firstStepFields, setFirstStepFields] = useState({
    ndsList: [
      {
        Id: 1,
        Name: i18n.t('constants.ndsList.1')
      },
      {
        Id: 2,
        Name: i18n.t('constants.ndsList.2')
      }
    ],

    name: '',
    orgFormId: orgFormId,
    country: countryId,
    dateRegistration: '',
    inn: '',
    ogrn: '',
    ogrnip: '',
    okpo: '',
    atiCode: '',
    kpp: '',
    workWithNds: workWithNds,
    taxType: taxType,
    taxPercent: taxPercent,
    noAtiCode: false,
    archiveByInn: false,
  });

  const [secondStepFields, setSecondStepFields] = useState({
    legalReasonsList: [
      {
        Id: 'Устав',
        Name: i18n.t('constants.legalReasonsList.1')
      },
      {
        Id: 'Приказ',
        Name: i18n.t('constants.legalReasonsList.2')
      },
      {
        Id: 'Доверенность (ООО)',
        Name: i18n.t('constants.legalReasonsList.3')
      }
    ],
    legalReason: '',
    firstName: '',
    secondName: '',
    patronymic: '',

    banksList: [],
    bic: '',
    bankName: '',
    bankCorS: '',
    rs: '',
    position: ''
  });

  const [thirdStepFields, setThirdStepFields] = useState({
    certificateNumber: '',
    certificateSerial: '',

    regAddressCheckBox: false,
    regRegionsList: [],
    regLocalitiesList: [],
    regStreetsList: [],
    regHousesList: [],
    regRegion: '',
    regLocality: '',
    regStreet: '',
    regHouseNumber: '',
    regPremiseNumber: '',
    regAddressPostalCode: '',

    factAddressCheckBox: false,
    mailingRegionsList: [],
    mailingLocalitiesList: [],
    mailingStreetsList: [],
    mailingHousesList: [],
    mailingRegion: '',
    mailingLocality: '',
    mailingStreet: '',
    mailingHouseNumber: '',
    mailingPremiseNumber: '',
    mailingAddressPostalCode: '',

    legalRegionsList: [],
    legalLocalitiesList: [],
    legalStreetsList: [],
    legalHousesList: [],
    legalRegion: '',
    legalLocality: '',
    legalStreet: '',
    legalHouseNumber: '',
    legalPremiseNumber: '',
    legalAddressPostalCode: '',

    guarantorFirstName: '',
    guarantorSecondName: '',
    guarantorPatronymic: '',
    guarantorPassportSerial: '',
    guarantorPassportNumber: '',
    guarantorPassportDivisionsList: [],
    guarantorPassportDivision: '',
    guarantorPassportRegistration: '',
    guarantorPassportDate: '',

    guarantorFactAddressCheckBox: false,
    guarantorFactRegionsList: [],
    guarantorFactLocalitiesList: [],
    guarantorFactStreetsList: [],
    guarantorFactHousesList: [],
    guarantorFactRegion: '',
    guarantorFactLocality: '',
    guarantorFactStreet: '',
    guarantorFactHouseNumber: '',
    guarantorFactPremiseNumber: '',
    guarantorFactAddressPostalCode: '',

    guarantorRegRegionsList: [],
    guarantorRegLocalitiesList: [],
    guarantorRegStreetsList: [],
    guarantorRegHousesList: [],
    guarantorRegRegion: '',
    guarantorRegLocality: '',
    guarantorRegStreet: '',
    guarantorRegHouseNumber: '',
    guarantorRegPremiseNumber: '',
    guarantorRegAddressPostalCode: '',
  });

  const [fourthStepFields, setFourthStepFields] = useState({
    guarantorFirstName: '',
    guarantorSecondName: '',
    guarantorPatronymic: '',
    guarantorPassportSerial: '',
    guarantorPassportNumber: '',
    guarantorPassportDivisionsList: [],
    guarantorPassportDivision: '',
    guarantorPassportRegistration: '',
    guarantorPassportDate: '',

    guarantorFactAddressCheckBox: false,
    guarantorFactRegionsList: [],
    guarantorFactLocalitiesList: [],
    guarantorFactStreetsList: [],
    guarantorFactHousesList: [],
    guarantorFactRegion: '',
    guarantorFactLocality: '',
    guarantorFactStreet: '',
    guarantorFactHouseNumber: '',
    guarantorFactPremiseNumber: '',
    guarantorFactAddressPostalCode: '',

    guarantorRegRegionsList: [],
    guarantorRegLocalitiesList: [],
    guarantorRegStreetsList: [],
    guarantorRegHousesList: [],
    guarantorRegRegion: '',
    guarantorRegLocality: '',
    guarantorRegStreet: '',
    guarantorRegHouseNumber: '',
    guarantorRegPremiseNumber: '',
    guarantorRegAddressPostalCode: '',
  });

  const [fifthStepFields, setFifthStepFields] = useState({
    // Общие
    partnerCard: [],
    copyOfThePassport: [],
    powerOfAttorneyForAPerson: [],
    copyOfBankCard: [],
    certificateOfStateRegistration: [],

    incomeTaxForTheLastReportingPeriod: [],
    NDSReturnForTheLastReportingPeriod: [],
    bookkeepingBalance: [],

    // ИП
    certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority: [],
    // Не ИП
    charterWithAllAmendments: [],
    protocolOfTheGeneralMeetingOfParticipants: [],
    registrationOfALegalEntityWithTaxAuthority: [],
    proofOfOwnership: [],

    //ТНВ
    registeredMemorandumOfAssociation: [],
    decisionToCreate: [],
    requisites: [],
  });

  const [innInfoErr, setInnInfoErr] = useState(null);

  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
        ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
          return fieldErrors + "; " + error;
        })
        : null;
  };

  useEffect(() => {
    setFifthStepFields({
      // Общие
      partnerCard: [],
      copyOfThePassport: [],
      powerOfAttorneyForAPerson: [],
      copyOfBankCard: [],
      certificateOfStateRegistration: [],

      incomeTaxForTheLastReportingPeriod: [],
      nDSReturnForTheLastReportingPeriod: [],
      bookkeepingBalance: [],
      certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget: [],
      staffingTable: [],
      documentsConfirmingTax: [],

      // ИП
      dischargeFromEGRIP: [],
      certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority: [],
      certificateOfCalculationsWithTheBudget: [],
      // Не ИП
      dischargeFromEGRUL: [],
      charterWithAllAmendments: [],
      decisionToCreateSociety: [],
      protocolOfTheGeneralMeetingOfParticipants: [],
      certificateOfEntry: [],
      registrationOfALegalEntityWithTaxAuthority: [],
      // bookkeepingBalance: [],
      profitsAndLossesReport: [],
      incomeTaxAndNDSDeclaration: [],
      proofOfOwnership: []
    });
  }, [currentStep]);

  useEffect(() => {
    if (isActive) {
      if (isProprietor || purposeType === 'consignor_purpose_type') {
        setStepsList([
          i18n.t('components.createRusLegalEntity.tabs.6'),
          i18n.t('components.createRusLegalEntity.tabs.7'),
          i18n.t('components.createRusLegalEntity.tabs.2'),
          i18n.t('components.createRusLegalEntity.tabs.3'),
          i18n.t('components.createRusLegalEntity.tabs.5')
        ]);
      } else {
        setStepsList([
          i18n.t('components.createRusLegalEntity.tabs.6'),
          i18n.t('components.createRusLegalEntity.tabs.7'),
          i18n.t('components.createRusLegalEntity.tabs.2'),
          i18n.t('components.createRusLegalEntity.tabs.3'),
          i18n.t('components.createRusLegalEntity.tabs.5')
        ]);
      }
    }
  }, [isActive]);

  useEffect(() => {
    if (changeStepEvent) {
      if (changeStepEvent === 'next') {
        nextStep();
      } else if (changeStepEvent === 'previous') {
        previousStep();
      }

      setChangeStepEvent('');
    }
  }, [changeStepEvent]);

  useEffect(() => {
    if (createLegalEntityEvent) {
      setLoading(true);

      let data = Object.assign(firstStepFields, secondStepFields, thirdStepFields, fourthStepFields);
      companyService.createLegalEntity(data, fifthStepFields, isProprietor, purposeType, isAgree)
          .then(response => {
            if (response.code === 400) {
              notification.error({
                message: i18n.t('components.notification.titles.createLegalEntity'),
                description: getErrorDescription(response.message),
              });
              setFieldsErrors(response.errors);
            } else {
              notification.success({
                message: i18n.t('components.notification.titles.createLegalEntity'),
                description: response.message,
              });
              if (typeof setShowModal === 'function') {
                setShowModal(false);
              }
              if (typeof setIsShowParent === 'function') {
                setIsShowParent(false);
              }
           
            }

            setCreateLegalEntityEvent(false);
            setLoading(false);
          })
          .catch(errMsg => {
            notification.error({
              message: i18n.t('components.notification.titles.createLegalEntity'),
              description: getErrorDescription(errMsg),
            });

            setLoading(false);
            setCreateLegalEntityEvent(false);
          });
    }
  }, [createLegalEntityEvent]);

  const incrementStep = () => {
        if (currentStep < 6) {
            if ((currentStep + 1) === 5) {
                setCurrentStep(currentStep + 2);
            } else {
                setCurrentStep(currentStep + 1);
            }
            setFieldsErrors([]);
        }
    };

  const nextStep = () => {
    const stepData = (currentStep) => {
      let stepFields = {
        2: firstStepFields,
        3: secondStepFields,
        4: thirdStepFields,
        5: fourthStepFields,
        6: fifthStepFields
      };

      // Баг. Без этого вместо stepFields undefiend

      return stepFields[currentStep];
    };

    setLoading(true);

    let step = currentStep;
    if (currentStep === 1) {
        if (!firstStepFields.inn) {
            setFieldsErrors({
                inn: [i18n.t('components.createRusLegalEntity.errors.inn')],
            });
            setLoading(false);
            return;
        }

        if (!firstStepFields.atiCode) {
            setFieldsErrors({
                atiCode: [i18n.t('components.createRusLegalEntity.errors.atiCode')]
            });
            setLoading(false);
            return;
        }

        setInnInfoErr(null);
        legalEntityService.getNewLegalEntityInfo({inn: firstStepFields.inn})
            .then((resp) => {
                setFirstStepFields({
                    ...firstStepFields,
                    name: resp.name,
                    ogrn: resp.ogrn,
                    ogrnip: resp.ogrnip,
                    dateRegistration: resp.dateRegistration ?  moment(resp.dateRegistration, 'DD.MM.YYYY') : '',
                    okpo: resp.okpo,
                    kpp: resp.kpp,
                });
                setSecondStepFields({
                    ...secondStepFields,
                    firstName: resp.firstName,
                    secondName: resp.secondName,
                    patronymic: resp.patronymic,
                    position: resp.position ? stringsHelper.ucFirst(resp.position) : '',
                });
                setThirdStepFields({
                    ...thirdStepFields,
                    legalRegion: resp.regionAoguid !== null ? resp.regionAoguid : '',
                    legalLocality: resp.localityAoguid !== null ? resp.localityAoguid : '',
                    legalStreet: resp.streetAoguid !== null ? resp.streetAoguid : '',
                    legalHouseNumber: resp.houseAoguid !== null ? resp.houseAoguid : '',
                });

                setLoading(false);
                incrementStep();
            })
            .catch((err) => {
                setInnInfoErr(err);
                notification.error({
                    message: i18n.t('components.notification.titles.getNewLegalEntityInfo'),
                    description: getErrorDescription(err),
                });
                setFieldsErrors({
                    inn: [err]
                });
                setLoading(false);
            });
        return;
    } else {
        step -= 1;
    }

    companyService
      .createLegalEntityValidateStepData(stepData(currentStep), step, orgFormId, countryId, false, false, isProprietor)
      .then(response => {
        setLoading(false);

        if (response.status === 'success') {
          incrementStep();
        } else {
          setFieldsErrors(response.errors);
        }
      })
      .catch(error => {
          setLoading(false);
          notification.error({
            message: i18n.t('components.notification.titles.createLegalEntityValidateStepData'),
            description: getErrorDescription(error),
          });
        });
  };

  const previousStep = () => {
        if (currentStep > 0) {
            if (currentStep === 6) {
                setCurrentStep(currentStep - 2);
                return;
            }
            setCurrentStep(currentStep - 1);
        } else {
            setCurrentStep(0);
        }
    };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
            <FillInnStep
                setFields={setFirstStepFields}
                stepFields={firstStepFields}
                getFieldErrors={getFieldErrors}
                isProprietor={isProprietor}
                innInfoError={innInfoErr}
                setInnInfoErr={setInnInfoErr}
                nextStepFunc={incrementStep}
            />
        );
      case 2:
          return (
              <FirstStep
                  setFields={setFirstStepFields}
                  stepFields={firstStepFields}
                  getFieldErrors={getFieldErrors}
                  isProprietor={isProprietor}
              />
          );
      case 3:
          return (
              <SecondStep
                  setFields={setSecondStepFields}
                  stepFields={secondStepFields}
                  getFieldErrors={getFieldErrors}
                  organizationalForm={firstStepFields.orgFormId}
                  country={firstStepFields.country}
                  isProprietor={isProprietor}
              />
          );
      case 4:
          return (
              <ThirdStep
                  setFields={setThirdStepFields}
                  stepFields={thirdStepFields}
                  getFieldErrors={getFieldErrors}
                  country={firstStepFields.country}
                  isProprietor={isProprietor}
                  currentStep={currentStep}
              />
          );
      case 5:
          return (
              <FourthStep
                  setFields={setFourthStepFields}
                  stepFields={fourthStepFields}
                  getFieldErrors={getFieldErrors}
                  country={firstStepFields.country}
                  isProprietor={isProprietor}
              />
          );
        case 6:
            return (
                <FifthStep
                    setFields={setFifthStepFields}
                    stepFields={fifthStepFields}
                    getFieldErrors={getFieldErrors}
                    organizationalForm={firstStepFields.orgFormId}
                    isNeedPowerOfAttorneyForAPerson={(secondStepFields.legalReason === 'Доверенность (ООО)')}
                    isNdsPayer={(firstStepFields.workWithNds === 1)}
                    isProprietor={isProprietor}
                    purposeType={purposeType}
                    taxType={firstStepFields.taxType}
                />
            );
      default:
        return <div />;
    }
  };

  return (
      <div>
        {renderCurrentStep()}
        <ModalListShipCompanies isShow={showModalListShipCompanies} setIsShow={setShowModalListShipCompanies} legalEntityId={legalEntityId} setIsShowParent={setIsShowParent} />
      </div>
  );
}
